// libs
import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedUserService } from '@luggagehero/shared/services/users';

import { BaseComponent } from '../../../core';
@Component({
  template: '',
  standalone: false,
})
export class UserBaseComponent extends BaseComponent implements OnInit {
  private userService = inject(SharedUserService);
  private router = inject(Router);

  ngOnInit() {
    if (this.userService.isLoggedIn) {
      void this.router.navigate(['user/account']);
    }
  }
}
